export default "__VITE_ASSET__4e0b5b93__"